import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState
} from 'react';
import GeneralContext from '../../GeneralContext';
import ReminderCardDateView from '../view/ReminderCardDateView';

const ReminderCardDateEngine = ({
  actionButtons,
  reminderData,
  update,
  onDisabledClicked,
  title,
  setTitle,
  updateTitle,
  ...props
}) => {
  const { form } = useContext(GeneralContext);

  const [intervalCount, setIntervalCount] = useState(
    reminderData.condition.interval
  );
  const [statusesDD, setStatusesDD] = useState([]);
  const oldStatusDDValues = useRef([]);

  useEffect(() => {
    // const isAnonymous = form.sharingType === 'anonymous'; // TODO: handle this, hide invalid options
    let newStatusesDD = [];
    if (form && form.customStatuses && reminderData) {
      newStatusesDD = form.customStatuses.map(s => ({
        text: `Status: ${s.label}`,
        value: s.internalId,
        'data-testid': `status-${s.label}-${reminderData.id}`
      }));
    }
    newStatusesDD.unshift({
      text: `All submissions`,
      value: 'all',
      'data-testid': `status-all-${reminderData.id}`
    });

    setStatusesDD(newStatusesDD);
    oldStatusDDValues.current = reminderData.condition.statusList || [];
  }, [form]);

  const onStatusDDChange = useCallback(
    valuesArray => {
      const isAllSelected = oldStatusDDValues.current.includes('all');
      let newValues = [];

      if (valuesArray.includes('all') && !isAllSelected) {
        newValues = ['all', ...statusesDD.map(s => s.value)];
      } else if (valuesArray.includes('all') && isAllSelected) {
        newValues = valuesArray.filter(s => s !== 'all');
      } else {
        newValues = valuesArray;
      }

      oldStatusDDValues.current = newValues;

      update({ 'condition.statusList': newValues });
    },
    [statusesDD, update]
  );

  const viewProps = {
    reminderData,
    update,
    onDisabledClicked,
    actionButtons,
    intervalCount,
    setIntervalCount,
    title,
    setTitle,
    updateTitle,
    logicRules: reminderData.condition.logicRules
      ? JSON.parse(reminderData.condition.logicRules)
      : [],
    hideRecurring:
      reminderData &&
      reminderData.recurrence &&
      reminderData.recurrence.recurrenceType === 'time',
    statusesDD,
    onStatusDDChange,
    ...props
  };

  return <ReminderCardDateView {...viewProps} />;
};

export default ReminderCardDateEngine;
